
<div>
  <v-dialog persistent
    scrollable
    v-model="showPreview"
    @keydown.esc="closePreview"
    class="preview-dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card v-if="file" class="d-flex flex-column">
      <v-toolbar height="80px" style="flex: 0 0 auto">
        <p>
          <b>{{ file.filename }}</b>
        </p>
        <v-spacer></v-spacer>
        <a :href="downloadPath" :download="file.filename" target="_blank">
          <v-btn small text>
            <v-icon>mdi-download</v-icon> Download
          </v-btn>
        </a>
        <v-btn icon @click="closePreview">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container
        fluid
        class="grey lighten-1 d-flex flex-column"
        :style="[previewLoaded ? { 'display': 'block' } : { 'display': 'none !important' },
                { 'flex': '1 1 auto' },
                { 'overflow-y': 'scroll' },
                { 'overflow-x': 'hidden' }]"
      >
        <img @load="sourceLoaded" class="mx-auto" v-if="previewTypeImage === 'image'" :src="file.url" style="max-width: 80%; max-height: 100%"></img>
        <div v-else-if="previewType === 'application/pdf'" class="pdf">
          <pdf
            v-for="i in pdfPages"
            :key="i"
            :src="file.url"
            :page="i"
            style="width: 60%;"
            class="mx-auto"
            @loaded="sourceLoaded"
          ></pdf>
        </div>
        <video @load="sourceLoaded" class="mx-auto" controls v-else-if="previewType === 'video/mp4'" :src="file.url" style="max-width: 80%;"></video>
        <h1 v-else class="grey--text ma-auto">No preview available for this type of document.</h1>
      </v-container>
      <v-container v-if="!previewLoaded" fluid class="grey lighten-1 d-flex flex-column" style="flex: 1 1 auto; overflow-y: scroll; overflow-x: hidden">
        <h1 class="grey--text ma-auto">Loading preview...</h1>
      </v-container>
    </v-card>
  </v-dialog>
</div>
